"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var encrypt = function (text, key, revert) {
    if (revert === void 0) { revert = false; }
    if (text === null)
        return '';
    var newText = '';
    for (var i = 0; i < text.length; i++) {
        newText += String.fromCharCode(text.charCodeAt(i) + (revert ? key.charCodeAt(Math.abs(key.length - i) % key.length) : key.charCodeAt(i % key.length)));
    }
    return newText;
};
var decrypt = function (text, key, revert) {
    if (revert === void 0) { revert = false; }
    if (text == null)
        return '';
    var newText = '';
    for (var i = 0; i < text.length; i++) {
        newText += String.fromCharCode(text.charCodeAt(i) - (revert ? key.charCodeAt(Math.abs(key.length - i) % key.length) : key.charCodeAt(i % key.length)));
    }
    return newText;
};
var Encode = {
    encrypt: encrypt,
    decrypt: decrypt,
};
exports.default = Encode;
//# sourceMappingURL=Encode.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/saffroncodejs/lib/libs/Encode.js
// module id = 37
// module chunks = 0